define('plugin/category/view/CategoryItemView',['require','lib/view/LayoutView','lib/theme/ThemeSettings'],function (require) {

	var LayoutView = require('lib/view/LayoutView');
	var ThemeSettings = require('lib/theme/ThemeSettings');
	
	/**
	 * Category info view (category item)
	 * 
	 * @class CategoryItemView
	 */
	return LayoutView.extend({

		getTemplate: function () {
			if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
				return '#category_item_list';
			}
			return '#category_item';
		}
	    
	});
	
});
